<template>
  <button
    :id="`repayment-type_${repaymentTypeOption.repaymentTypeId}`"
    class="repayment-option-button repayment-option-button-wrapper"
    :class="[
      `repayment-option-button-${size}`,
      {
        active: repaymentTypeOption.repaymentTypeId === selectedRepaymentTypeId,
        'default-btn': repaymentTypeOption.repaymentTypeId !== selectedRepaymentTypeId,
      },
    ]"
  >
    <div class="button-header">
      <div class="button-title-wrapper">
        <h5 class="button-title">{{ repaymentTypeOption?.repaymentTypeDetails?.name }}</h5>
      </div>
      <div class="tooltip-wrapper" :style="buttonStyle">
        <tooltip-component ref="tooltipComponentRef" class="bottom-left">
          <template #toggle>
            <icon icon="info" />
          </template>
          <div class="rates-tooltip">
            <p>
              {{
                repaymentTypeOption?.repaymentTypeDetails?.tooltipText ||
                repaymentTypeOption?.repaymentTypeDetails?.description
              }}
            </p>
          </div>
        </tooltip-component>
      </div>
    </div>
    <div class="button-content">
      <div class="info-values">
        <div class="info">
          <span>{{ repaymentTypeOption.repayment?.monthlyInSchoolPaymentLabel }}</span>
          <span>{{ repaymentTypeOption.monthlyInSchoolPaymentDisplay }}</span>
        </div>
        <div class="info">
          <span>{{ repaymentTypeOption.repayment?.monthlyPostSchoolPaymentLabel }}</span>
          <span>{{ repaymentTypeOption.monthlyPostSchoolPaymentDisplay }}</span>
        </div>
        <div class="info">
          <span>Interest Rate</span>
          <span>{{ repaymentTypeOption?.rateDisplay || interestRate }}</span>
        </div>
      </div>
    </div>
  </button>
</template>

<script setup lang="ts">
import { defineProps, withDefaults, ref, computed, onMounted, onUnmounted } from "vue";
import Icon from "@/components/shared/Icon.vue";
import TooltipComponent from "@/components/shared/TooltipComponent.vue";
import { RepaymentTypes } from "@/config/enums";
import { useStore } from "vuex";

const store = useStore();

interface Props {
  readonly: boolean;
  repaymentTypeOption: any;
  selectedRepaymentTypeId?: number;
  size?: "sm" | "lg";
}

const props = withDefaults(defineProps<Props>(), {
  readonly: true,
  selectedRepaymentTypeId: 0,
  size: "lg",
});

const tooltipComponentRef = ref<InstanceType<typeof TooltipComponent>>();

const interestRate = computed<string>(
  () => store.state.loanConfigurationModule.selectedRatePlan?.rateDisplay || "—%",
);

const buttonStyle = computed<Record<string, number>>(() => {
  return {
    "--buttonZIndexDesktop": getTooltipZIndex(props.repaymentTypeOption?.repaymentTypeId),
  };
});
function getTooltipPosition(repaymentType: any) {
  switch (repaymentType) {
    case RepaymentTypes.Deferred:
    case RepaymentTypes.Flat:
      return "bottom-left xs-bottom-left";
    default:
      return "";
  }
}

function getTooltipZIndex(repaymentType: any) {
  switch (repaymentType) {
    case RepaymentTypes.Deferred:
    case RepaymentTypes.Regular:
      return 2;
    default:
      return 1;
  }
}
</script>

<style scoped src="@/styles/professional-grad/repayment-type-button.css"></style>
